import React from 'react';
import { ModalComponent } from 'components/layout/modals/ModalComponent';
import { Formik } from 'formik';
import { ClientContactForm } from './ClientContactForm';
import * as Yup from 'yup';
import { clientStore } from '../ClientStore';
import { notificationStore } from 'components/layout/notifications/NotificationStore';
import { modalStore } from 'components/layout/modals/ModalStore';

const ValidationSchema = Yup.object().shape({
	clientContact: Yup.object().shape({
		isPrimary: Yup.boolean().required().label('Is Primary'),
		name: Yup.string().required().label('Name'),
		role: Yup.string().required().label('Role'),
		slackId: Yup.string().label('Slack ID'),
		email: Yup.string().email().label('Email'),
		phone: Yup.string().label('Phone')
	})
});

export class ClientContactCreate extends ModalComponent {
	render() {
		return (
			<Formik
				initialValues={{
					clientContact: {
						isPrimary: false,
						name: '',
						role: '',
						slackId: '',
						email: '',
						phone: ''
					}
				}}
				validationSchema={ValidationSchema}
				onSubmit={values => {
					this.saving();
					this.create(values);
				}}>
				{formikBag =>
					this.renderModalContainer(formikBag, 'ClientContactCreate')
				}
			</Formik>
		);
	}

	renderForm(formikBag) {
		return (
			<ClientContactForm
				data={formikBag.values.clientContact}
				onChange={(field, value) => {
					formikBag.setFieldValue('clientContact', {
						...formikBag.values.clientContact,
						[field]: value
					});
				}}
			/>
		);
	}

	async create(values) {
		const { clientContact } = values;
		clientStore
			.createClientContact(this.props.clientId, clientContact)
			.then(result => {
				if (result.status === 'success') {
					notificationStore.pushNotification({
						type: notificationStore.SUCCESS_NOTIFICATION,
						title: 'Create Client Contact',
						message: 'The client contact has been successfully created.'
					});
					this.closeWithSuccess();
				} else {
					notificationStore.pushNotification({
						type: notificationStore.ERROR_NOTIFICATION,
						title: 'Create Client Contact',
						message: 'An error has occurred. Please try again.'
					});
					modalStore.closeDialog();
				}
			});
	}
}
